import { render, staticRenderFns } from "./CoBrandingShareModal.vue?vue&type=template&id=349d8638&lang=pug&"
import script from "./CoBrandingShareModal.vue?vue&type=script&lang=js&"
export * from "./CoBrandingShareModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports